<template>
  <ModalDialog
    ref="dialog"
    title="Inventory Bin Contents"
    :showSubmit="false"
    :scrollable="true"
    icon="fa-inventory"
    @closed="onClosed">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <div v-if="!loading && !loadingError">
      <StaticDataTable class="static-table-list">
        <template v-slot:header>
          <tr>
            <th>Type</th>
            <th>Barcode</th>
            <th>Size</th>
            <th>Quantity</th>
            <th>Stock</th>
          </tr>
        </template>
        <template v-slot:body>
          <template v-for="(linkInfo, index) in inventoryBinContents">
            <tr :key="index">
              <td class="font-weight-bold">{{contentTypeName(linkInfo.linkType)}}</td>
              <td>
                {{formatHyphenEmptyValue(linkInfo.data.barcode)}}
              </td>
              <td>{{contentTypeSize(linkInfo)}}</td>
              <td>{{contentTypeQuantity(linkInfo)}}</td>
              <td><LinkStock :id="linkInfo.data.stock.id" :name="`${linkInfo.data.stock.code} - ${linkInfo.data.stock.name}`" /></td>
            </tr>
          </template>
        </template>

      </StaticDataTable>
    </div>


  </ModalDialog>
</template>


<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { LinkTypes, LinkTypeLookup, InventoryBinCodeTypes, InventoryBinLinkTypes } from '@/store/types'

export default {
  name: 'InventoryBinContentsDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    inventoryBinId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',

      inventoryBin: {},
      inventoryBinContents: []
    }
  },
  created() {
    this.InventoryBinCodeTypes = InventoryBinCodeTypes
    this.LinkTypeLookup = LinkTypeLookup
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    show() {
      this.submitting = false

      this.requestData()

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    requestData() {
      this.loading = true
      this.loadingError = ''

      Promise.all([
        this.$apiService.inventoryService.getInventoryBin(this.inventoryBinId),
        this.$apiService.inventoryService.getInventoryBinContents(this.inventoryBinId)
      ])
      .then(results => {
        this.inventoryBin = results[0].data
        this.inventoryBinContents = results[1].data
      })
      .catch(err => {
        this.loadingError = 'Error loading data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    contentTypeName(linkType) {
      var lookup = {
        [LinkTypes.inventoryBinLink]: 'Loose Stock',
        [LinkTypes.productionPanel]: 'Production Panel',
        [LinkTypes.glassBlock]: 'Glass Block',
        [LinkTypes.glassLevel]: 'Glass Offcut',
      }

      return lookup[linkType]
    },
    contentTypeSize(contentsInfo) {
      switch(contentsInfo.linkType) {
        case LinkTypes.inventoryBinLink:
          if(contentsInfo.data.type == InventoryBinLinkTypes.glassLevel)
            return `${contentsInfo.data.glassLevel.height} x ${contentsInfo.data.glassLevel.width}`
          if(contentsInfo.data.type == InventoryBinLinkTypes.stock)
            return `-`
          return '-'

        case LinkTypes.productionPanel:
          return `${contentsInfo.data.panelHeight} x ${contentsInfo.data.panelWidth}`
        case LinkTypes.glassBlock:
          return `${contentsInfo.data.height} x ${contentsInfo.data.height}`
        case LinkTypes.glassLevel:
          return `${contentsInfo.data.height} x ${contentsInfo.data.height}`

        default:
          return '-'
      }
    },
    contentTypeQuantity(contentsInfo) {
      switch(contentsInfo.linkType) {
        case LinkTypes.inventoryBinLink:
          return contentsInfo.data.quantity
        case LinkTypes.productionPanel:
          return 1
        case LinkTypes.glassBlock:
          return `${contentsInfo.data.sheetQuantity} sheets`
        case LinkTypes.glassLevel:
          return 1

        default:
          return '-'
      }
    }
  }
}
</script>